/*
  Makes the "Sort by:" label in the mobile filter drawer open its dropdown.

  A native <label for> only moves focus to a <select> — it never opens the option
  list — so the label text was a dead tap target. Suppress the label's default
  forwarding and open the picker explicitly instead.

  Delegated from document because facets.js replaces the drawer markup on every
  filter change, which would drop a directly bound listener.
*/

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const label = target.closest('.mobile-facets__wrapper .mobile-facets__sort label');
  if (!label) return;

  const select = label.parentElement.querySelector('.select__select');

  // Without showPicker there is no way to open a native dropdown from script, so
  // leave the default label behaviour alone rather than swallowing the click.
  if (!select || typeof select.showPicker !== 'function') return;

  event.preventDefault();

  try {
    select.showPicker();
  } catch (error) {
    select.focus();
  }
});
